var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/more_option.c470c987.png","uri@2x": __webpack_public_path__ + "static/media/more_option.17a56e6b.png","uri@3x": __webpack_public_path__ + "static/media/more_option.35061100.png",
    width: 50,
    height: 50
});